import { useCoaBsi, useCoaByCode, useTaxCode, useAccounts, useCoaItem } from "utils"
import { Loading } from "components"

export function JournalProductInventory(params: {
    product_id: string
}) {
    const { data, isLoading } = useCoaBsi(params.product_id)

    if (isLoading) {
        return (
            <td>
                <Loading loading />
            </td>
        )
    }

    return <td>{data}</td>
}

export function JournalProductByBSI(params: {
    product_id: string
    code:string
}) {
    const { data, isLoading } = useCoaItem(params.product_id)

    if (isLoading) {
        return (
            <td>
                <Loading loading />
            </td>
        )
    }

    if(params.code === "buy"){
        return <td>{`${data?.coa_buy_code} ${data?.coa_buy_name}`}</td>
    }else if(params.code === "sell"){
        return <td>{`${data?.coa_sell_code} ${data?.coa_sell_name}`}</td>
    }
    return <td>{`${data?.coa_inv_code} ${data?.coa_inv_name}`}</td>
}


export function JournalLinkedAccount(params: {
    coa_code: string
}) {
    const { data, isLoading } = useCoaByCode(params.coa_code)

    if (isLoading) {
        return (
            <td>
                <Loading loading />
            </td>
        )
    }

    return <td>{data}</td>
}

export function JournalLinkedAccountById(params: {
    coa_id: number
}) {
    const { data, isLoading } = useAccounts()
    const account = data.find(item => Number(item.value) === params.coa_id) ?? null
    
    if (isLoading) {
        return (
            <td>
                <Loading loading />
            </td>
        )
    }

    return <td>{account?.label}</td>
}

export function JournalTaxAccount(params: {
    tax_id: string
    isPaid?: boolean
}) {
    const { data, isLoading } = useTaxCode()
    const selectedTaxCode = data.find(i => i.value === params.tax_id)

    if (isLoading) {
        return (
            <td>
                <Loading loading />
            </td>
        )
    }

    if (params.isPaid === false) {
        return <td>{selectedTaxCode?.tax_coa_collect}</td>
    }
    return <td>{selectedTaxCode?.tax_coa_paid}</td>
}